// extracted by mini-css-extract-plugin
export var aircallIframe = "_l8-3";
export var fabContainer = "_l8-5";
export var fabRinging = "_l8-6";
export var loadingOverlay = "_l8-4";
export var pulse = "_l8-7";
export var widgetContent = "_l8-2";
export var widgetPanel = "_l8-0";
export var widgetPanelExpanded = "_l8-1";